<template>
    <v-dialog persistent v-model="dialog" max-width="430px">
        <v-card id="qj-dialog-configuration-approach-flow">
            <v-card-text class="pa-0">
                <v-form ref="form" lazy-validation>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 class="pb-0">
                                <v-subheader class="px-1">Distribuição de orçamento </br> por porcentagem</v-subheader>
                            </v-flex>
                            <v-flex xs12>
                                <v-data-table
                                    :headers="distributionHeaders"
                                    :items="approachRulesTypes"
                                    hide-actions
                                    :key="percentValuesStringfied"
                                >
                                    <template v-slot:items="props">
                                        <td @click="markAsEdited(props.item)">
                                            <span :class="`tag-approach-type small ${props.item}`">{{
                                                props.item
                                            }}</span>
                                        </td>
                                        <td>
                                            <v-layout>
                                                <v-text-field
                                                    v-model="percentValues[props.item]"
                                                    class='pl-5 pr-4 centered-input'
                                                    background-color="grey lighten-3"
                                                    append-outer-icon="percent"
                                                    :maxlength="3"
                                                    :rules="rules"
                                                    :ref="props.item"
                                                    @input="handleEdited(props.item)"
                                                    @focus="markFocus(props.item)"
                                                ></v-text-field>
                                            </v-layout>
                                        </td>
                                        <td @click="markAsEdited(props.item)">
                                            <v-layout justify-center>
                                                <v-icon 
                                                    small 
                                                    color="blue"
                                                    v-if="alreadyEdited.includes(props.item)"
                                                    key="username-input"
                                                >
                                                    verified
                                                </v-icon>
                                            </v-layout>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions class="pr-3 pb-3 pl-3">
                        <v-layout column>
                            <v-layout class="ma-0 mr-2 mb-2" v-if="errorMessage">
                                <span style="color:red" v-html="errorMessage"></span>
                            </v-layout>
                            <v-layout>
                                <v-btn color="error" class="ma-0 mr-2" @click="clearAll">
                                    Limpar
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="grey lighten-1" class="ma-0 mr-2" @click="$emit('update:dialog', false)">
                                    Cancelar
                                </v-btn>
                                <v-btn color="accent" class="ma-0" @click="saveApproach" :disabled="disableSaveButton">
                                    Salvar
                                </v-btn>
                            </v-layout>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import approachService from "@/services/consolidation-tree/approach-flow";

export default {
    props: ["dialog", "data", "approach_id", "approachFlow", "flowRules"],
    data() {
        return {  
            disableSaveButton: false,
            errorMessage: null,
            onFocusInput: null,
            percentValuesStringfied: null,
            domainModel: [],
            approachId: null,
            percentValues: {},
            alreadyEdited: [],
            approachRulesTypes: [],
            approach: { configurations: {} },
            rules:[
                value => ((0 <= value && value <= 100) || !value) || ''
            ],
            stimulusBudget: 100,
            distributionHeaders: [
                {
                    text: "Tipo da abordagem",
                    align: "left",
                    sortable: false,
                    width: "30%",
                },
                {
                    text: "Porcentagem",
                    align: "center",
                    sortable: false,
                    width: "35%",
                },
                {
                    text: "Editado",
                    align: "right",
                    sortable: false,
                    width: "5%",
                },
            ],
        };
    },
    // mounted() {
    //     this.alreadyEdited = []
    // },
    methods: {
        clearAll(){
            this.alreadyEdited = []
            this.percentValues = {}
            this.errorMessage = null
            this.disableSaveButton = false
        },
        markFocus(type_) {
            this.onFocusInput = type_
        },
        markAsEdited(type_) {
            if (!this.alreadyEdited.includes(type_)) {
                this.alreadyEdited.push(type_)
                let aux_ = Object.keys(this.percentValues)
                if (!aux_.includes(type_)) {
                    this.percentValues[type_] = null
                }
            }
        },
        updatePercent() {
            let len_edited = this.alreadyEdited.length

            let sum_values_edited = 0
            
            for (const idx in this.approachRulesTypes) {
                let tp = this.approachRulesTypes[idx]
                if (this.alreadyEdited.includes(tp)) {
                    if (this.percentValues[tp] > 100) {
                        this.errorMessage = `Valor inválido para <b>${tp}</b>, passou de 100!`
                        this.disableSaveButton = true
                        return
                    } else if (this.percentValues[tp] < 0) {
                        this.errorMessage = `Valor inválido para <b>${tp}</b>, menor do que 0!`
                        this.disableSaveButton = true
                        return
                    }
                    sum_values_edited += parseFloat(this.percentValues[tp])
                }
            }
            if (sum_values_edited > 100) {
                this.errorMessage = `Somatório das porcentagens editadas está em <b>${sum_values_edited}</b>, <br>passou de <b>100</b>!`
                this.disableSaveButton = true
                return
            }

            let len_approach_types = this.approachRulesTypes.length
            let partial_percentage = null;

            if (len_edited > 0) {
                partial_percentage = Math.max(0, (100 - sum_values_edited) / (len_approach_types-len_edited))
                if (!partial_percentage) {
                    partial_percentage = 0
                }
                for (const idx in this.approachRulesTypes) {
                    let type_ = this.approachRulesTypes[idx]
                    
                    if (!this.alreadyEdited.includes(type_)) {
                        this.percentValues[type_] = partial_percentage.toFixed(2)
                    }
                }
            }
            this.percentValuesStringfied = JSON.stringify(this.percentValues)
            
            this.$nextTick(() => {
                this.$refs[this.onFocusInput].focus();
            })
            this.errorMessage = null
            this.disableSaveButton = false
        },
        handleEdited(type_) {
            if (!this.alreadyEdited.includes(type_)) {
                this.alreadyEdited.push(type_)
            }
            this.updatePercent()
        },
        saveApproach() {
            let editeds = Object.keys(this.percentValues)
            if (editeds.length) {
                this.configurations.budget_distribution = Object.assign({}, this.percentValues)
            } else {
                delete this.configurations.budget_distribution
            };
            this.approach.configurations = Object.assign({}, this.configurations);
            this.edit();
        },
        edit() {
            let payload = {};
            Object.entries(this.approach).forEach(([index, item]) => {
                payload[index] = item;
            });

            approachService
                .update(this.approachId, payload)
                .then(async (res) => {
                    this.$emit("update:dialog", false);
                    window.location.reload();
                })
                .catch((e) => {
                    this.$store.commit("showSnackbar", `Houve um erro ao salvar!`);
                });
            
        },
    },
    watch: {
        async dialog() {
            if (this.dialog) {
                this.approachRulesTypes = [...new Set(this.flowRules.objects.map(obj => obj.type))]
                this.approachRulesTypes = this.approachRulesTypes.filter(function(value, index, arr){ 
                    return value != 'PUSH';
                });
                this.approachId = this.approach_id;
                this.configurations = { ...this.data };
                if (this.configurations.budget_distribution) {
                    this.percentValues = Object.assign({}, this.configurations.budget_distribution)
                }
            } else {
                this.approach = {};
                this.alreadyEdited = []
                this.percentValues = {}
            }
        },
    },
}
</script>

<style lang="scss">  
  tbody {
    tr:hover {
    background-color: transparent !important;
    }

  }
.v-input__icon.v-input__icon--append-outer i {
  font-size: 18px;
//   padding-left: 10px;
}
.centered-input input {
  text-align: center;
}
</style>

